import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Modal, Btn } from "@/components/ui-kit";
import { Printer } from "lucide-react";

export function LabelCard({ title, code, lines = [], badge, stamp }) {
  const info = lines.length ? lines.slice(0, 2) : stamp ? [["", stamp]] : [];
  return (
    <div className="label-card flex overflow-hidden bg-white text-black" style={{ width: "50mm", height: "25mm", padding: "1.2mm", gap: "1.4mm", boxSizing: "border-box" }}>
      <QRCodeSVG value={code} size={256} level="M" marginSize={0} style={{ width: "22.6mm", height: "22.6mm", flexShrink: 0 }} />
      <div className="flex min-w-0 flex-1 flex-col justify-between" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
        <div>
          <div className="font-bold leading-none" style={{ fontSize: code.length > 14 ? "2.1mm" : "2.45mm", whiteSpace: "nowrap", letterSpacing: "-0.05mm" }} data-testid="label-code">{code}</div>
          <div className="mt-[0.6mm] font-sans font-bold uppercase leading-tight" style={{ fontSize: "2.2mm", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{title}</div>
        </div>
        <div className="leading-tight" style={{ fontSize: "1.9mm" }}>
          {info.map((l, i) => <div key={i} className="truncate"><b>{l[0]}</b> {l[1]}</div>)}
        </div>
        <div className="flex items-center justify-between gap-1">
          {badge ? <span className="truncate border border-black px-[0.5mm] font-bold uppercase" style={{ fontSize: "1.6mm" }}>{badge}</span> : <span />}
          <img src="/logo-amax.png" alt="amax" style={{ height: "2.2mm", width: "auto" }} />
        </div>
      </div>
    </div>
  );
}

// `labels`: optional array of LabelCard props — prints one label per page (per-unit labels).
export default function QRLabel({ open, onClose, title, code, lines = [], stamp, badge, labels, heading = "QR / Barcode Label" }) {
  if (!open) return null;
  const list = labels && labels.length ? labels : [{ title, code, lines, stamp, badge }];
  return (
    <Modal open={open} onClose={onClose} title={heading} wide={list.length > 1}>
      <div className="space-y-4">
        <div id="print-label" className={`print-sheet label-sheet mx-auto flex max-h-[60vh] flex-col items-center gap-3 overflow-y-auto py-2`} data-testid="label-preview">
          {list.map((l, i) => <LabelCard key={i} {...l} />)}
        </div>
        <div className="no-print flex items-center justify-between gap-2">
          <span className="font-mono text-[11px] text-muted-foreground" data-testid="label-count">{list.length} label{list.length > 1 ? "s" : ""}</span>
          <div className="flex gap-2">
            <Btn variant="outline" onClick={onClose} data-testid="label-close-btn">Close</Btn>
            <Btn onClick={() => window.print()} data-testid="print-label-btn">
              <Printer size={15} /> Print {list.length > 1 ? `${list.length} Labels` : "Label"}
            </Btn>
          </div>
        </div>
        <p className="no-print text-center text-[11px] text-muted-foreground">
          Label size 50 × 25 mm (2 × 1 in). In the print dialog choose your label printer, paper 50 × 25 mm, margins “None”, scale 100%. Multiple labels print one per label.
        </p>
      </div>
    </Modal>
  );
}
